/* eslint-disable react/no-array-index-key */
import React from 'react';

import imageSources from '../../../../constants/imageSources/imageSources';
import * as Styled from './styles';

const HTMLEditMessage = () => (
    <div role="menuitem">
        <Styled.Wrapper role="button" tabIndex={0}>
            <Styled.Text data-test-id="html-edit-message-text">
                Looking to edit the HTML? You can now do this in the text toolbar.
            </Styled.Text>
            <Styled.ArrowImg src={imageSources.PANEL.EDIT_HTML_ARROW} alt="Edit HTML icon preview arrow indicator" />
            <Styled.IconImg src={imageSources.PANEL.EDIT_HTML_ICON} alt="Edit HTML icon preview" />
        </Styled.Wrapper>
    </div>
);

export default HTMLEditMessage;
